import { PlatformTypeEnum } from '@/common/constants';
import { usePartyStore } from '@/features/parties/store/usePartyStore';
import useStore from '@/lib/store';
import { cn } from '@/lib/utils';
import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ILoad } from '../../models';
import { useLoadStore } from '../../store';
import { EditParties } from '../edit-parties';

interface IProps {
  load: ILoad | null;
  isLoad?: boolean;
}

export const AnalysisData: FC<IProps> = ({ load, isLoad = false }) => {
  const { t } = useTranslation();
  const { cropTypes, partiesSelectGeneral, fetchPartiesSelect } =
    usePartyStore();
  const { user } = useStore();
  const { loadGrain } = useLoadStore();
  const isCotton = user?.platform_type === PlatformTypeEnum.COTTON;

  useEffect(() => {
    fetchPartiesSelect(load?.crop_type_id, load?.harvest_type);
  }, [load]);

  const analysisCropType = useMemo(() => {
    return cropTypes?.find((el) => el?.value == load?.crop_type_id)?.label;
  }, [cropTypes, load]);

  const party = useMemo(() => {
    const item = partiesSelectGeneral?.find((el) => el?.id === load?.party_id);

    return `${item?.place_number || '-'} - ${item?.party_number || '-'} `;
  }, [partiesSelectGeneral, load]);

  const list = useMemo(() => {
    return [
      {
        title: t('selection.type'),
        value: analysisCropType || '---',
      },
      {
        title: t('pollution'),
        value: load?.analysis?.pollution
          ? load?.analysis?.pollution + '%'
          : '---',
      },
      {
        title: t('humidity'),
        value: load?.analysis?.humidity
          ? load?.analysis?.humidity + '%'
          : '---',
      },
      {
        title: t('industry.type'),
        value: load?.analysis?.industrial_grade || '---',
      },
      {
        title: t('class'),
        value: load?.analysis?.class || '---',
      },
      // {
      //   title: t('sort'),
      //   value: load?.fiber_type || '---',
      // },
      // {
      //   title: t('sort.by.code'),
      //   value: load?.fiber_code || '---',
      // },
    ];
  }, [load]);

  return (
    <div className={'grid grid-cols-5 w-full gap-4'}>
      {list?.map((field) => {
        return (
          <div key={field.title}>
            <p className="text-sm text-gray-600 mb-2">{field.title}:</p>
            <p className={(cn('text-base'), isLoad ? 'font-medium' : '')}>
              {field.value}
            </p>
          </div>
        );
      })}
      <div className="flex items-center gap-3">
        <div className="flex flex-col">
          <p className="text-sm text-gray-600 mb-1">{t('party')}:</p>
          <div className="flex items-center gap-2">
            <p className="text-base font-medium">
              {isCotton ? party : loadGrain?.party_number}{' '}
            </p>
            {!load?.analysis?.analysis_date && <EditParties />}
          </div>
        </div>
      </div>
    </div>
  );
};
